import React from "react";
import {Filter} from "../../common/components/Filter";
import withRouter from "../../common/hooks/withRouter";
import {connect} from "react-redux";
import {setTestcacheRecordsFilter, updateTestcacheFilters} from "../actions/TestcacheActions";

export class TestcacheSidebarFilters extends React.Component {


    handleCountryFilter = (filterOption) => {
        this.props.setTestcacheRecordsFilter(filterOption, "country");
        this.props.updateTestcacheFilters();
    }

    handleSourceTypeFilter = (filterOption) => {
        this.props.setTestcacheRecordsFilter(filterOption, "source_type");
        this.props.updateTestcacheFilters();

    }


    render() {
        return (
            <div className="sidebar-filter-container">
                <Filter
                    placeholder="Country"
                    handleFilter={this.handleCountryFilter}
                    options={this.props.testcacheFilterOptions.testcacheCountryOptions}
                    value={this.props.testcacheFilters.testcacheCountryFilter}
                />
                <Filter
                    placeholder="Data Source Type"
                    handleFilter={this.handleSourceTypeFilter}
                    options={this.props.testcacheFilterOptions.testcacheDataSourceTypeOptions}
                    value={this.props.testcacheFilters.testcacheDataSourceTypeFilter}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    serviceType: state.veritas.services.type,
    testcacheFilterOptions: state.support.testcache.testcacheFilterOptions,
    testcacheFilters: state.support.testcache.testcacheFilters,
    kyc_services: state.veritas.services.kyc_services,
});

const mapDispatchToProps = dispatch => ({
    setTestcacheRecordsFilter: (filterOption, type) => {dispatch(setTestcacheRecordsFilter(filterOption, type))},
    updateTestcacheFilters: () => {dispatch(updateTestcacheFilters())},
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(TestcacheSidebarFilters))
